import {
  type TeamExternalIntegration,
  type ResponseBodyEvaluation,
  type PredicateType,
  type EndpointResponse
} from 'types/api/status-checks/status-check'
import { IntegrationType } from 'utils/team-external-integrations/team-external-integration-types'
import { ENDPOINT_URLS } from 'utils/third-party'

export const dataDogUS5StatusCheckIntegration: TeamExternalIntegration = {
  name: 'Datadog US5',
  type: IntegrationType.DatadogUS5,
  authUrl: `${ENDPOINT_URLS.datadog_us5}v2/current_user/application_keys`,
  isPrivateNetworkIntegration: false,
  headers: [
    { key: 'DD-API-KEY', value: '', label: 'API Key' },
    {
      key: 'DD-APPLICATION-KEY',
      value: '',
      label: 'Application Key'
    }
  ],
  url: ENDPOINT_URLS.datadog_us5,
  sortIndex: 0
}

export const datadogUS5MonitorRegex = new RegExp(
  '^https:\\/\\/(us5).datadoghq.com\\/(monitors|api/v1/monitor)\\/(.+\\d)'
)

export const datadogUS5ResponseBodyEvaluationConfiguration: ResponseBodyEvaluation =
  {
    op: 'AND',
    predicates: [
      {
        jpQuery: '.overall_state',
        type: 'String' as PredicateType,
        comparator: 'EQU',
        rValue: 'OK'
      }
    ]
  }

export function getDatadogUS5MonitorIdFromUrl(url: string): string {
  return datadogUS5MonitorRegex.exec(url)?.[3]
}

export function convertToDatadogUS5ApiUrl(url: string): string {
  if (datadogUS5MonitorRegex.test(url)) {
    const isAPIUrl = datadogUS5MonitorRegex.exec(url)?.[2] === 'api/v1/monitor'
    const monitorId = getDatadogUS5MonitorIdFromUrl(url)

    if (isAPIUrl) {
      return url
    }

    if (monitorId) {
      return `https://us5.datadoghq.com/api/v1/monitor/${monitorId}`
    }
  }

  return null
}

export function getDatadogUS5MonitorName(
  testEndpointResponse: EndpointResponse
): string {
  return JSON.parse(testEndpointResponse?.responseBody)?.name
}
